import { render, staticRenderFns } from "./TourAttachModal.vue?vue&type=template&id=a3c605c4"
import script from "./TourAttachModal.vue?vue&type=script&lang=js"
export * from "./TourAttachModal.vue?vue&type=script&lang=js"
import style0 from "./TourAttachModal.vue?vue&type=style&index=0&id=a3c605c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports